import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import BuyInvoiceForm from "@components/forms/BuyInvoiceForm";
import AddProductToDocumentOffCanvas from "@components/layout/Offcanvas/AddProductToDocumentOffCanvas";
import DocumentReferencesOffCanvas from "@components/layout/Offcanvas/DocumentReferencesOffCanvas";
import { OpenDocumentReferencesPubSub } from "@utils/pubsubs/PubSub";
import { useAppSelector } from "@/store/hooks";
import { BuyInvoiceType } from "@utils/Constants";

type BuyInvoiceAddProps = {
  copyData?: boolean
  buyInvoiceType: BuyInvoiceType
}

const BuyInvoiceAdd = (props: BuyInvoiceAddProps) => {
  const { copyData = false, buyInvoiceType } = props
  const documentReferences = useAppSelector((state) => state.eDocument.documentReferences)
  const params = useParams()
  const { id: copyBuyInvoiceId, quoteId } = params;

  const backUrl = `/user/buyInvoice${buyInvoiceType == "Expense" ? "Expenses" : "s"}`

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title="Agregar Factura de Compra"
      backUrl={backUrl}
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "buyInvoiceAdd",
          type: "submit",
          color: "success"
        },
        {
          customElement: (
            <AddProductToDocumentOffCanvas
              hideTemplate
              btnColor="success">
              Agregar Producto
            </AddProductToDocumentOffCanvas>
          )
        }
      ]}
      secondaryActions={[
        {
          actionTitle: `Referencias de Documento (${documentReferences.length})`,
          onClick: () => {
            OpenDocumentReferencesPubSub.publish({ openOffCanvas: true, documentKind: "BuyInvoice" })
          }
        }
      ]}
    >
      <BuyInvoiceForm
        id={copyBuyInvoiceId}
        copyData={copyData}
        buyInvoiceType={buyInvoiceType}
        saveRedirectUrl={backUrl}
        formId="buyInvoiceAdd" >
      </BuyInvoiceForm>

      <DocumentReferencesOffCanvas />
    </PageContainer>
  );
}

export default BuyInvoiceAdd;
